import React from 'react';
import { CircularProgress } from '@mui/material';
import useTranslation from 'Hooks/useTranslation';
import DocumentCard from 'Components/DocumentCard';
import bytesToSize from 'Utils/BytesToSize';
import { DocumentContainer, LoadingContainer } from './style';
import useDocumentsTab from './Hooks/useDocumentsTab';

export default function Documents({ course }) {
  const { t2 } = useTranslation('CourseDetails');

  const courseId = course?.id;

  // ? Hook para menejar los datos de esta pestaña.
  const { loading, documents } = useDocumentsTab(courseId);

  // Si esta cargando muestro un spinner
  if (loading) {
    return (
      <LoadingContainer>
        <CircularProgress color="success" />
      </LoadingContainer>
    );
  }

  // Si no hay documentos o esta cargando
  if (documents.length === 0) {
    return <LoadingContainer>{t2('NoDocuments')}</LoadingContainer>;
  }

  return (
    <DocumentContainer>
      {documents.map(doc => {
        return (
          <DocumentCard
            key={doc.key}
            fileName={doc.fileName}
            fileExtension={doc.fileName.split('.').pop()}
            size={bytesToSize(doc.size)}
            document={doc}
            fileLocation={doc.key}
          />
        );
      })}
    </DocumentContainer>
  );
}
